module.exports = new __parcel__URL__("apply_c_faq_closed_btn_en.b9f0a47c.webp").toString();